const Icons = {
  Ic_logo: require("../Assets/Icons/Ic_logo.png"),
  




};
export default Icons;
